var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"padding":"0"}},[_c('v-card',{attrs:{"height":"50vh"}},[_c('v-col',[_c('div',{staticClass:"text-h4 px-2 pt-10 text--center text--secondary block"},[_vm._v(" ABOUT PAGE ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }